import { useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import UpdateEmailModal from "./updateEmailModal";
import UpdatePhoneModal from "./updatePhoneModal";
import { useSelector } from "react-redux";
import UpdateSocialModal from "./updateSocialModal";

const ContactInformation = ({ fetchConfig }) => {
  const [isUpdateEmailOpen, setIsUpdateEmailOpen] = useState(false);
  const [isUpdatePhoneOpen, setIsUpdatePhoneOpen] = useState(false);
  const [isUpdateSocialOpen, setIsUpdateSocialOpen] = useState(false);
  const [socialMedia, setSocialMedia] = useState("");
  const { config } = useSelector((state) => state.config);

  return (
    <div>
      <div className="my-3">
        <div className="card">
          <div className="card-body">
            <table className="table table-borderless mb-0">
              <tbody>
                <tr>
                  <td className="fw-semibold">Email:</td>
                  <td>{config?.contactInfo?.email}</td>
                  <td>
                    <button
                      className="btn"
                      onClick={() => setIsUpdateEmailOpen(true)}
                    >
                      <FaRegEdit size={26} />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="fw-semibold">Contact Number:</td>
                  <td>{config?.contactInfo?.phoneNo}</td>
                  <td>
                    <button
                      className="btn"
                      onClick={() => setIsUpdatePhoneOpen(true)}
                    >
                      <FaRegEdit size={26} />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="fw-semibold">Facebook:</td>
                  <td>{config?.contactInfo?.facebook}</td>
                  <td>
                    <button
                      className="btn"
                      onClick={() => {
                        setSocialMedia("facebook");
                        setIsUpdateSocialOpen(true);
                      }}
                    >
                      <FaRegEdit size={26} />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="fw-semibold">Instagram:</td>
                  <td>{config?.contactInfo?.instagram}</td>
                  <td>
                    <button
                      className="btn"
                      onClick={() => {
                        setSocialMedia("instagram");
                        setIsUpdateSocialOpen(true);
                      }}
                    >
                      <FaRegEdit size={26} />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td className="fw-semibold">Twitter:</td>
                  <td>{config?.contactInfo?.twitter}</td>
                  <td>
                    <button
                      className="btn"
                      onClick={() => {
                        setSocialMedia("twitter");
                        setIsUpdateSocialOpen(true);
                      }}
                    >
                      <FaRegEdit size={26} />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <UpdateEmailModal
        isUpdateOpen={isUpdateEmailOpen}
        closeUpdateModal={() => setIsUpdateEmailOpen(false)}
        fetchConfig={fetchConfig}
      />
      <UpdatePhoneModal
        isUpdateOpen={isUpdatePhoneOpen}
        closeUpdateModal={() => setIsUpdatePhoneOpen(false)}
        fetchConfig={fetchConfig}
      />
      <UpdateSocialModal
        isUpdateOpen={isUpdateSocialOpen}
        closeUpdateModal={() => setIsUpdateSocialOpen(false)}
        fetchConfig={fetchConfig}
        socialMedia={socialMedia}
      />
    </div>
  );
};

export default ContactInformation;
